import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import { navbarHeight } from '../App';
import Footer from '../components/Footer';
import ContactSection from '../components/ContactSection';
import ProjectsSection from '../components/ProjectsSection';
import ReactGA from 'react-ga4';

const Home = ({ theme, setTheme }) => {

  ReactGA.send({ hitType: "pageview", page: "/", title: "HomePageViews" });

  return (
    <div className="bg-light dark:bg-dark overflow-hidden">
      <div className='min-h-screen'>
        <div className='relative w-screen bg-light-accent dark:bg-dark-accent'>
          <Navbar theme={theme} setTheme={setTheme}/> 
          <HeroSection theme={theme} setTheme={setTheme} style={{paddingTop: navbarHeight}}/>
        </div>
        <div className='m-4 md:m-auto max-w-3xl'>
          <AboutSection className='mt-20'/>
          <ProjectsSection/>
        </div>
        {/* <ContactSection/> */}
      </div>  
      <Footer/>
    </div>  
  )
}

export default Home